import axios from 'axios'

const DEFAULT_BASE_URL = import.meta.env.VITE_BASE_URL
axios.defaults.baseURL = DEFAULT_BASE_URL
